module.exports = __webpack_public_path__ + "double-anno-it-mobile.jpg";